import { render, staticRenderFns } from "./CuentaCRUD.vue?vue&type=template&id=352b9275"
import script from "./CuentaCRUD.vue?vue&type=script&lang=js"
export * from "./CuentaCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports